module.exports = __webpack_public_path__ + "static/img/ACC2.bb8f4abd.png";